import { defaultSignatureInputDialogDescription } from "@/components/ui/signature-input";

export const caregiverAppClientSignatureDialogDescription = `${defaultSignatureInputDialogDescription} Any attempt to forge a client signature is illegal and could result in serious consequences.`;
export const caregiverAppSignatureDisclaimer =
	"By signing, you attest that all visit details are accurate and truthful to the best of your knowledge. Any attempt to forge a client signature is illegal and could result in serious consequences.";

export const caregiverAppVerbalConfirmationDisclaimer =
	"By recording, the client attests that all visit details are accurate and truthful to the best of their knowledge. This recording serves as a legally binding confirmation equivalent to a handwritten signature. Any attempt to forge or fabricate a client voice recording is illegal and could result in serious consequences.";

export const caregiverAppVerbalConfirmationInstructions = [
	"Hold the device close to the client (within arm's reach of their mouth).",
	'Tap "Record Confirmation" below.',
	"The client must clearly state their full name and confirm that the visit details are accurate.",
	'Tap "Stop Recording" when the client is finished speaking.',
] as const;
